import React, { Component } from 'react'
import FriendForm from './FriendForm'
import { Button, Collapse, Icon } from '@blueprintjs/core';
import { Translate } from "react-redux-i18n";

class SendInvitesToFriends extends Component {   
    state = {
        isOpen: false,
        keepChildrenMounted: false,
    };
  
    toggleFriendsForm = () =>{
        if(!this.state.isOpen){
            this.props.newMemberForm();
        }else{
            this.props.removeFriends();
        }
        this.setState({ isOpen: !this.state.isOpen });
    } 
    
        
    
    render() {
        return (
            <div className="b2b-invite-friends">
                <div onClick={this.toggleFriendsForm} className="invite-friends-trigger">
                    <Translate value="b2b.send_invites" />
                </div>
                <Collapse isOpen={this.state.isOpen} className="invite-friends-collapse">
                    {
                        Object.values(this.props.friends).map((friend, index)=>
                        <FriendForm 
                            key={index}
                            id={friend.id} 
                            removeMember={this.removeMember}
                            updateFields={this.props.updateFields}
                            form_errors={this.props.errors}
                            removeFriend={this.props.removeFriend}
                            changeChanelType={this.props.changeChanelType} 
                            />
                        ) 
                    }
                    <Button onClick={this.props.newMemberForm} className="new-friend-cta">
                        <Icon icon="plus" className="icon" /> <Translate value="b2b.add_new_friend" />
                    </Button>
                </Collapse>
            </div>
        )
    }
}

export default SendInvitesToFriends;